(() => {
  function initCardSwiper(el) {
    if (el.dataset.cardSwiperInitialized) return;
    el.dataset.cardSwiperInitialized = '1';

    // The position bar lives below the image (outside .media) so it never
    // overlaps the photo, so it's a sibling of .card rather than a child of
    // this swiper root — look it up via the shared .card-wrapper ancestor.
    const cardWrapper = el.closest('.card-wrapper');
    const scrollbarEl = cardWrapper ? cardWrapper.querySelector('.card__swiper-scrollbar') : null;

    new Swiper(el, {
      slidesPerView: 1,
      speed: 400,
      grabCursor: true,
      watchOverflow: true,
      simulateTouch: true,
      navigation: {
        nextEl: el.querySelector('.card__swiper-button-next'),
        prevEl: el.querySelector('.card__swiper-button-prev'),
      },
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
          }
        : undefined,
      a11y: {
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
      },
    });
  }

  function buildSrcset(previewImage, widths) {
    const url = new URL(previewImage.src);
    return widths
      .filter((w) => w <= previewImage.width)
      .map((w) => {
        url.searchParams.set('width', String(w));
        return `${url.href} ${w}w`;
      })
      .join(', ');
  }

  // assets/product-card.js already swaps the card image on swatch click, but
  // only for cards using the old .media--first/.media--second markup — it
  // no-ops (including skipping the add-to-cart variant id / link updates)
  // once a card renders the GUCCI-style .card__swiper gallery instead. This
  // covers that case independently so swatches stay fully functional.
  function initCardSwatch(wrapper) {
    const swiperEl = wrapper.querySelector('.card__swiper');
    if (!swiperEl || wrapper.dataset.cardSwiperSwatchBound) return;
    wrapper.dataset.cardSwiperSwatchBound = '1';

    wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
      input.addEventListener('click', (evt) => {
        if (!evt.currentTarget.checked) return;

        const link = wrapper.querySelector('.js-color-swatches-link');
        if (link) link.setAttribute('href', evt.currentTarget.dataset.variantLink);

        const addBtn = wrapper.querySelector('.card__add-to-cart button[name="add"]');
        if (addBtn) {
          addBtn.setAttribute('aria-disabled', 'false');
          const span = addBtn.querySelector('span');
          if (span) span.classList.remove('hidden');
          const soldOutMsg = addBtn.querySelector('.sold-out-message');
          if (soldOutMsg) soldOutMsg.classList.add('hidden');
        }
        const idInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
        if (idInput) idInput.value = evt.currentTarget.dataset.variantId;

        const optionValue = evt.currentTarget.value;
        const productHandle = wrapper.dataset.product;
        const firstSlideImg = swiperEl.querySelector('.swiper-slide img');
        if (!productHandle || !firstSlideImg || !window.Shopify) return;

        fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
          .then((res) => {
            if (res.ok) return res.json();
            throw new Error('Network response was not ok');
          })
          .then((productJson) => {
            const matchedVariant = productJson.variants.filter(
              (v) => v.featured_media != null && v.options.includes(optionValue)
            )[0];
            if (!matchedVariant) return;

            const preview = matchedVariant.featured_media.preview_image;
            if (firstSlideImg.src === preview.src) return;

            firstSlideImg.src = preview.src;
            firstSlideImg.srcset = buildSrcset(preview, [165, 360, 533, 720, 940, 1066]);
            firstSlideImg.alt = matchedVariant.featured_media.alt || productJson.title;

            if (swiperEl.swiper) swiperEl.swiper.slideTo(0, 0);
          })
          .catch((err) => console.error('There was a problem with the fetch operation:', err));
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.card__swiper').forEach(initCardSwiper);
    (root || document).querySelectorAll('.js-color-swatches-wrapper').forEach(initCardSwatch);
  }

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card__swiper')) {
          initCardSwiper(node);
        } else if (node.querySelectorAll) {
          initAll(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
